<template>
  <section class="page-panel record-return-condition">
    <header class="page-panel__header"><h3 class="panel-title">Stanje vozila pri vraćanju</h3></header>
    <div class="page-panel__content grid grid-column-gap-16 grid-row-gap-18">
      <div class="col-12">
        <RecordReadOnlyField v-if="readonly" label="Km stanje" :value="values.returnMileageKm === '' ? '' : `${values.returnMileageKm} km`" required />
        <AppTextField v-else :model-value="values.returnMileageKm" label="Km stanje" placeholder="npr. 45200" type="number" suffix="km" required :rules="mileageRules" @update:model-value="$emit('change', 'returnMileageKm', $event)" />
      </div>
      <div class="col-12 col-sm-6">
        <RecordReadOnlyField v-if="readonly" label="Datum vraćanja" :value="values.returnDate ? formatDate(values.returnDate) : ''" required />
        <AppDateField v-else :model-value="values.returnDate" label="Datum vraćanja" required @update:model-value="$emit('change', 'returnDate', $event)" />
      </div>
      <div class="col-12 col-sm-6">
        <RecordReadOnlyField v-if="readonly" label="Vrijeme vraćanja" :value="values.returnTime" required />
        <AppTimeField v-else :model-value="values.returnTime" label="Vrijeme vraćanja" required @update:model-value="$emit('change', 'returnTime', $event)" />
      </div>
      <div class="col-12 control">
        <div class="control-label">Voženo <span class="control__required">*</span></div>
        <div class="grid grid-column-gap-16 grid-row-gap-18">
          <div class="col-12 col-sm-6">
            <div v-if="readonly" class="record-return-condition__duration-value">{{ drivenDuration.days === '' ? '' : `${drivenDuration.days} ${drivenDuration.dayUnit}` }}</div>
            <AppTextField v-else :model-value="drivenDuration.days" :suffix="drivenDuration.dayUnit" readonly />
          </div>
          <div class="col-12 col-sm-6">
            <div v-if="readonly" class="record-return-condition__duration-value">{{ drivenDuration.hours === '' ? '' : `${drivenDuration.hours} ${drivenDuration.hourUnit}` }}</div>
            <AppTextField v-else :model-value="drivenDuration.hours" :suffix="drivenDuration.hourUnit" readonly />
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-6">
        <RecordReadOnlyField v-if="readonly" label="Stanje napunjenosti baterije" :value="values.returnBatteryPercent === '' ? '' : `${values.returnBatteryPercent} %`" />
        <AppTextField v-else :model-value="values.returnBatteryPercent" label="Stanje napunjenosti baterije" type="number" suffix="%" :rules="batteryRules" @update:model-value="$emit('change', 'returnBatteryPercent', $event)" />
      </div>
      <div class="col-12 col-sm-6">
        <RecordReadOnlyField v-if="readonly" label="Razina goriva u spremniku" :value="values.returnFuelLevel" />
        <AppTextField v-else :model-value="values.returnFuelLevel" label="Razina goriva u spremniku" :rules="fuelRules" @update:model-value="$emit('change', 'returnFuelLevel', $event)" />
      </div>
      <div class="col-12">
        <RecordReadOnlyField v-if="readonly" label="Oštećenja evidentirana kod povrata vozila" :value="values.returnDamage" />
        <AppTextarea v-else :model-value="values.returnDamage" label="Oštećenja evidentirana kod povrata vozila" placeholder="Opišite vidljiva oštećenja vozila..." @update:model-value="$emit('change', 'returnDamage', $event)" />
      </div>
    </div>
  </section>
</template>

<script setup>
import { formatDate } from '../../helpers'
import AppDateField from '../AppDateField.vue'
import AppTextField from '../AppTextField.vue'
import AppTextarea from '../AppTextarea.vue'
import AppTimeField from '../AppTimeField.vue'
import RecordReadOnlyField from './RecordReadOnlyField.vue'

defineProps({
  values: { type: Object, required: true },
  drivenDuration: { type: Object, required: true },
  readonly: { type: Boolean, default: false },
})

defineEmits(['change'])

const mileageRules = [(value) => value === '' || (Number.isInteger(Number(value)) && Number(value) >= 0) || 'Unesite cijeli broj od 0 naviše']
const batteryRules = [(value) => value === '' || (Number.isInteger(Number(value)) && Number(value) >= 0 && Number(value) <= 100) || 'Unesite cijeli broj od 0 do 100']
const fuelRules = [(value) => String(value ?? '').length <= 50 || 'Najviše 50 znakova']
</script>

<style scoped lang="scss">
.record-return-condition {
  :deep(.v-text-field__suffix),
  &__duration-value {
    font-family: var(--font-family);
    font-size: 15px;
    font-weight: 300;
    line-height: 22px;
  }
}
</style>
